<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>
<div class="container-header"><div class="container-header-inner">
  @if (isLoading) { <app-loading-box></app-loading-box> }
  @else if (documento) {
    <div class="title-container"><h1 class="title-default">Detalhe da NFS-e emitida</h1></div>
    <div class="detalhe-card">
      <p><strong>Número:</strong> {{ documento.informacoesDocumento.numero }}</p>
      <p><strong>Código de verificação:</strong> {{ documento.informacoesDocumento.codigoVerificacao || 'Não informado' }}</p>
      <p><strong>Chave:</strong> {{ documento.informacoesDocumento.chave || 'Não informada' }}</p>
      <p><strong>Emissão:</strong> {{ documento.informacoesDocumento.dataEmissaoCompleta | date:'dd/MM/yyyy HH:mm' }}</p>
      <p><strong>Prestador:</strong> {{ documento.informacoesDocumento.prestador }}</p>
      <p><strong>Tomador:</strong> {{ documento.informacoesDocumento.tomador }}</p>
      <p><strong>Valor:</strong> {{ documento.resumo.valorTotal | currency:'BRL' }}</p>
      <p><strong>Base de cálculo ISS:</strong> {{ documento.tributosDeclarados.baseCalculoIss | currency:'BRL' }}</p>
      <p><strong>ISS:</strong> {{ documento.tributosDeclarados.valorIss | currency:'BRL' }}</p>
      <p><strong>ISS retido:</strong> {{ documento.tributosDeclarados.valorIssRetido | currency:'BRL' }}</p>
      <h2>Serviços</h2>
      @for (servico of documento.servicos; track servico.numero) {
        <p>{{ servico.descricao }} — {{ servico.valorTotal | currency:'BRL' }}</p>
      }
      <button type="button" (click)="voltar()">Voltar</button>
    </div>
  } @else { <h1 class="title-default">NFS-e emitida não encontrada</h1> }
</div></div>
